export default __webpack_public_path__ + "static/media/mpeg.8d8eeb79.svg";